import React, { Suspense, useState } from 'react';
import { Box, Loader } from '@wix/design-system';
import { defaultInlineCodeStyle } from './styles';
import { WidgetButton } from '../../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
import styles from './SyntaxHighlightingWidget.module.scss';
const MarkdownWrapper = /*#__PURE__*/React.lazy(async () => {
  const mdwrpModule = await import('./MarkdownWrapper');
  return {
    default: mdwrpModule.default
  };
});
export const SyntaxHighlightingWidget = _ref => {
  let {
    data: {
      markdownWithCode,
      copyButton = {
        showIconOnly: false,
        defaultText: 'Copy code',
        clickedText: 'Copied!'
      },
      showHideButton = {
        showIconOnly: false,
        defaultText: 'Collapse',
        clickedText: 'Expand'
      },
      language,
      codeTagStyle,
      codeBlockStyle = '',
      inlineCodeStyle = defaultInlineCodeStyle,
      isCodeCollapsed = false,
      primaryButton,
      secondaryButton
    },
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const [isWidgetCollapsed, setIsWidgetCollapsed] = useState(true);
  const handleSecondaryButtonClick = effects => {
    setIsWidgetCollapsed(prevState => !prevState);
    const handler = handleButtonClick('secondary_button_click', secondaryButton == null ? void 0 : secondaryButton.label);
    handler(effects);
  };
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects,
          codeSnippet: markdownWithCode
        }
      };
      context.onWidgetAction(SYNTAX_HIGHLIGHTING_WIDGET, onWidgetActionData);
    };
    return handler;
  };
  return /*#__PURE__*/React.createElement("div", null, !isWidgetCollapsed && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      align: "center",
      padding: "10px",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny",
      text: "Loading Code"
    })))
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "100%",
    width: "100%",
    direction: "vertical",
    boxSizing: "border-box",
    containerType: "inline-size"
  }, /*#__PURE__*/React.createElement(MarkdownWrapper, {
    markdownWithCode: markdownWithCode,
    copyButton: copyButton,
    showHideButton: showHideButton,
    language: language,
    codeTagStyle: codeTagStyle,
    codeBlockStyle: codeBlockStyle,
    inlineCodeStyle: inlineCodeStyle,
    isCodeCollapsed: isCodeCollapsed,
    onWidgetAction: context.onWidgetAction
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.footerButtonsContainer
  }, isWidgetCollapsed && (secondaryButton == null ? void 0 : secondaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: false,
    onEnable: enableControls
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    type: "textButton",
    context: context,
    onClick: handleSecondaryButtonClick,
    webAction: secondaryButton.webAction,
    respondText: secondaryButton.respondText,
    icon: secondaryButton.icon,
    sideEffect: secondaryButton.sideEffect,
    skin: secondaryButton.skin
  }, secondaryButton.label)), (primaryButton == null ? void 0 : primaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: () => {}
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    context: context,
    webAction: primaryButton.webAction,
    onClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    respondText: primaryButton.respondText,
    icon: primaryButton.icon,
    sideEffect: primaryButton.sideEffect,
    disabled: areControlsDisabled,
    skin: primaryButton.skin
  }, primaryButton.label))));
};
export const SYNTAX_HIGHLIGHTING_WIDGET = 'SYNTAX_HIGHLIGHTING_WIDGET';
//# sourceMappingURL=SyntaxHighlightingWidget.js.map